document.addEventListener(
  'DOMContentLoaded',
  function () {

    function filterProducts(
      location
    ) {

      if (!location) {

        return;
      }

      location =
        location
          .toLowerCase()
          .trim();

      const cards =
        document.querySelectorAll(
          '.location-product-card'
        );

      cards.forEach(
        (card) => {

          const saifaiStore =
String(card.dataset.saifaiStore || '')
.trim()
.toLowerCase();

const kanpurStore =
String(card.dataset.kanpurStore || '')
.trim()
.toLowerCase();

const karhalStore =
  String(card.dataset.karhalStore || '')
    .trim()
    .toLowerCase();

          const saifai =
  String(card.dataset.saifai || '')
    .trim()
    .toLowerCase();

const palava =
  String(card.dataset.palava || '')
    .trim()
    .toLowerCase();

      const karhal =
  String(card.dataset.karhal || '')
    .trim()
    .toLowerCase();

          let available =
            true;
            let storeAvailable = true;

          /* -------------------------
             LOCATION CHECK
          -------------------------- */
         if (location === 'saifai') {

  available =
    saifai === 'true' ||
    saifai === '1' ||
    saifai === 'yes';

  storeAvailable =
    saifaiStore === 'true';
}

if (location === 'kanpur') {

  available =
    palava === 'true' ||
    palava === '1' ||
    palava === 'yes';

  storeAvailable =
    kanpurStore === 'true';
}

if (location === 'karhal') {

  available =
    karhal === 'true' ||
    karhal === '1' ||
    karhal === 'yes';

    storeAvailable =
    karhalStore === 'true';
}

available = available && storeAvailable;

          // Product always visible
          card.style.display =
            '';

    //         const productForm =
    // addToCartBtn?.closest('form');
          /* -------------------------
             BUTTON FINDER
          -------------------------- */
          const addToCartBtn =
            card.querySelector(`
              button[type="submit"],
              .product-form__submit,
              .quick-add__submit,
              [name="add"],
              a.button,
              .button,
              .card__button
            `);
            const productForm =
    addToCartBtn?.closest('form');

          if (
            !addToCartBtn
          ) {

            console.log(
              "❌ Button not found"
            );

            return;
          }

          /* -------------------------
             AVAILABLE
          -------------------------- */
          if (
            available
          ) {

            addToCartBtn.classList.remove(
              'location-disabled'
            );

            addToCartBtn.removeAttribute(
              'disabled'
            );

            addToCartBtn.style.pointerEvents =
              'auto';

            addToCartBtn.style.opacity =
              '1';

            addToCartBtn.style.cursor =
              'pointer';

            // Restore button text
            if (
              addToCartBtn.dataset
                .originalText
            ) {

              // addToCartBtn.innerHTML =
              //   addToCartBtn.dataset
              //     .originalText;
              const text = addToCartBtn.querySelector('span');

if (text && addToCartBtn.dataset.originalText) {
    text.textContent = addToCartBtn.dataset.originalText;
}

            } else {

              // addToCartBtn.innerHTML =
              //   'Add to cart';
              const text = addToCartBtn.querySelector('span');

if (text) {
    text.textContent = 'Add to cart';
}
            }
          }

          /* -------------------------
             NOT AVAILABLE
          -------------------------- */
          else {

            // Save original text
            if (
              !addToCartBtn.dataset
                .originalText
            ) {

              // addToCartBtn.dataset
              //   .originalText =
              //   addToCartBtn.innerHTML;
              const text = addToCartBtn.querySelector('span');

if (text) {
    addToCartBtn.dataset.originalText = text.textContent;
}
            }

            addToCartBtn.setAttribute(
              'disabled',
              'true'
            );

            addToCartBtn.style.pointerEvents =
              'none';

            addToCartBtn.style.opacity =
              '0.6';

            addToCartBtn.style.cursor =
              'not-allowed';

            // addToCartBtn.innerHTML =
            //   'Not Available';
//             const text = addToCartBtn.querySelector('span');

// if (text) {
//     text.textContent = 'Not Available';
// }
const text = addToCartBtn.querySelector('span');

if (text) {

    if (!storeAvailable) {
        text.textContent = 'Sold out';
    } else {
        text.textContent = 'Not Available';
    }

}

            addToCartBtn.classList.add(
              'location-disabled'
            );
          }
        }
      );
    }

    /* -------------------------
       LOAD FROM SESSION
    -------------------------- */
    const savedLocation =
  localStorage.getItem(
    'selected_location'
  );

    if (
      savedLocation
    ) {

      filterProducts(
        savedLocation
      );
    }

    /* -------------------------
       LIVE LOCATION UPDATE
    -------------------------- */
    window.addEventListener(
      'locationUpdated',
      function (e) {

        const location =
  e.detail ||
  localStorage.getItem(
    'selected_location'
  );

        filterProducts(
          location
        );
      }
    );

 
    
    
    /* -------------------------
   PRODUCT PAGE
-------------------------- */
function updateProductPageButtons() {

  const location =
  localStorage.getItem(
    'selected_location'
  );

  if (!location) return;

  const productData =
    document.querySelector(
      '.product-location-data'
    );

  if (!productData) {

    return;
  }
  const variantId =
    document.querySelector(
        'input[name="id"]'
    )?.value;


// const variantData =
//   window.variantLocations?.[
//     variantId
//   ];

// console.log(
//   'Current Variant',
//   variantId,
//   variantData
// );

// if (variantData) {

//   productData.dataset.saifai =
//     String(
//       variantData.saifai || ''
//     )
//     .trim()
//     .toLowerCase();

//   productData.dataset.palava =
//     String(
//       variantData.palava || ''
//     )
//     .trim()
//     .toLowerCase();
// }
const variantData =
window.variantLocations?.[
variantId
];

if (variantData) {

    productData.dataset.saifai =
        String(
            variantData.saifai ??
            productData.dataset.productSaifai
        )
        .trim()
        .toLowerCase();

    productData.dataset.palava =
        String(
            variantData.palava ??
            productData.dataset.productPalava
        )
        .trim()
        .toLowerCase();

    productData.dataset.karhal =
    String(
        variantData.karhal ??
        productData.dataset.productKarhal ??
        ''
    )
    .trim()
    .toLowerCase();

} else {

    productData.dataset.saifai =
        String(
            productData.dataset.productSaifai
        )
        .trim()
        .toLowerCase();

    productData.dataset.palava =
        String(
            productData.dataset.productPalava
        )
        .trim()
        .toLowerCase();
      
    productData.dataset.karhal =
        String(
            productData.dataset.productKarhal || ''
        )
        .trim()
        .toLowerCase();
}

/* -------------------------
   STORE AVAILABILITY
-------------------------- */

const storeAvailability =
    window.variantStoreAvailability?.[variantId] || {};

console.log("Current Store Availability", storeAvailability);

let storeAvailable = true;

const currentLocation =
    location.toLowerCase().trim();

if (currentLocation === "saifai") {
    storeAvailable =
        storeAvailability["saifai-store"] !== false;
}

if (currentLocation === "kanpur") {
    storeAvailable =
        storeAvailability["jajmau-kanpur-store"] !== false;
}

if (currentLocation === "karhal") {
    storeAvailable =
        storeAvailability["karhal-zipgro-store"] !== false;
}


  const saifai =
  String(productData.dataset.saifai || '')
    .trim()
    .toLowerCase();

const palava =
  String(productData.dataset.palava || '')
    .trim()
    .toLowerCase();

  const karhal =
  String(productData.dataset.karhal || '')
    .trim()
    .toLowerCase();

  let available =
    true;


//    const variantId =
// document.querySelector(
//   'input[name="id"]'
// )?.value;

// const storeAvailability =
// window.variantStoreAvailability?.[variantId] || {};

// let storeAvailable = true;

  /* -------------------------
     LOCATION CHECK
  -------------------------- */
  if (location === 'saifai') {

    available =
      saifai === 'true' ||
      saifai === '1' ||
      saifai === 'yes';

    storeAvailable =
      storeAvailability['saifai-store'] !== false;
}

if (location === 'kanpur') {

    available =
      palava === 'true' ||
      palava === '1' ||
      palava === 'yes';

    storeAvailable =
      storeAvailability['jajmau-kanpur-store'] !== false;
}

if (location === 'karhal') {

  available =
    karhal === 'true' ||
    karhal === '1' ||
    karhal === 'yes';

    storeAvailable =
    storeAvailability['karhal-zipgro-store'] !== false;
}

  available = available && storeAvailable;

  /* -------------------------
     BUTTONS
  -------------------------- */
  const addToCartBtn =
    document.querySelector(`
      button[name="add"],
      .product-form__submit,
      button[type="submit"]
    `);
    const productForm =
    addToCartBtn?.closest('form');

const paymentWrapper =
document.querySelector('.shopify-payment-button');

const buyNowBtn =
paymentWrapper?.querySelector(
'.shopify-payment-button__button'
) ||
paymentWrapper?.querySelector('button') ||
paymentWrapper?.querySelector(
'.shopify-payment-button__button--unbranded'
);

/* Find iframe if Shopify renders one */
const paymentIframe =
paymentWrapper?.querySelector('iframe');

  /* -------------------------
     AVAILABLE
  -------------------------- */
  if (available) {

    addToCartBtn.removeAttribute('disabled');
    if (productForm) {
    productForm.classList.remove('location-disabled');
}
    // Add to cart
    if (
      addToCartBtn
    ) {

      addToCartBtn.disabled =
        false;

      addToCartBtn.removeAttribute(
        'disabled'
      );

      addToCartBtn.style.pointerEvents =
        'auto';

      addToCartBtn.style.opacity =
        '1';

      addToCartBtn.style.cursor =
        'pointer';

      // addToCartBtn.innerHTML =
      //   'Add to cart';
      const text = addToCartBtn.querySelector('span');

if (text) {
    text.textContent = 'Add to cart';
}
    }

    // Buy it now
  if (paymentWrapper) {

    paymentWrapper.style.pointerEvents = 'auto';
    paymentWrapper.style.opacity = '1';
    paymentWrapper.style.userSelect = 'auto';
}

if (buyNowBtn) {

    buyNowBtn.disabled = false;
    buyNowBtn.removeAttribute('disabled');

    buyNowBtn.style.pointerEvents = 'auto';
    buyNowBtn.style.cursor = 'pointer';

    buyNowBtn.onclick = null;
}

if (paymentIframe) {

    paymentIframe.style.pointerEvents = 'auto';
}

  }

  /* -------------------------
     NOT AVAILABLE
  -------------------------- */
  else {

    // Add to cart
    if (
      addToCartBtn
    ) {

      addToCartBtn.disabled =
        true;

      addToCartBtn.setAttribute(
        'disabled',
        true
      );

      if (productForm) {

    productForm.classList.add('location-disabled');
}

      addToCartBtn.style.pointerEvents =
        'none';

      addToCartBtn.style.opacity =
        '0.6';

      addToCartBtn.style.cursor =
        'not-allowed';

        addToCartBtn.onclick = function(e) {
    e.preventDefault();
    e.stopPropagation();
    return false;
};

      // addToCartBtn.innerHTML =
      //   'Not Available';
      const text = addToCartBtn.querySelector('span');

if (text) {
    // text.textContent = 'Not Available';
    if (!storeAvailable) {
        text.textContent = 'Sold out';
    } else {
        text.textContent = 'Not Available';
    }
}
    }

    // Buy it now
 if (paymentWrapper) {

    paymentWrapper.style.pointerEvents = 'none';
    paymentWrapper.style.opacity = '.5';

    paymentWrapper.style.userSelect = 'none';
}

if (buyNowBtn) {

    buyNowBtn.disabled = true;
    buyNowBtn.setAttribute('disabled', 'disabled');

    buyNowBtn.style.pointerEvents = 'none';
    buyNowBtn.style.cursor = 'not-allowed';

    buyNowBtn.onclick = function(e){
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        return false;
    };
}

if (paymentIframe) {

    paymentIframe.style.pointerEvents = 'none';
}
  }
}

/* -------------------------
   RUN MULTIPLE TIMES
-------------------------- */
updateProductPageButtons();

setTimeout(
  updateProductPageButtons,
  500
);

setTimeout(
  updateProductPageButtons,
  1500
);

setTimeout(
  updateProductPageButtons,
  3000
);


/* -------------------------
   VARIANT CHANGE FIX
-------------------------- */

// let currentVariantId = '';

// setInterval(() => {

//   const variantId =
//     document.querySelector(
//       'form[action*="/cart/add"] input[name="id"]'
//     )?.value;

//   if (
//     variantId &&
//     variantId !== currentVariantId
//   ) {

//     currentVariantId =
//       variantId;

//     console.log(
//       'Variant Changed:',
//       variantId
//     );

//     updateProductPageButtons();
//   }

// }, 100);

// const variantInput =
//   document.querySelector(
//     'input[name="id"]'
//   );

// if (variantInput) {

//   new MutationObserver(
//     () => {

//       updateProductPageButtons();

//     }
//   ).observe(
//     variantInput,
//     {
//       attributes: true,
//       attributeFilter: [
//         'value'
//       ]
//     }
//   );
// }

let currentVariantId = '';

setInterval(() => {

  const variantId =
    document.querySelector(
      'input[name="id"]'
    )?.value;

  if (
    variantId &&
    variantId !== currentVariantId
  ) {

    currentVariantId =
      variantId;

    console.log(
      'Variant Changed:',
      variantId
    );

    updateProductPageButtons();

    if (
      typeof updateLocationPricing ===
      'function'
    ) {

      updateLocationPricing(
        localStorage.getItem(
          'selected_location'
        )
      );
    }
  }

}, 100);

window.addEventListener(
  'locationUpdated',
  updateProductPageButtons
);


const location =
  localStorage.getItem(
    'selected_location'
  );

if (
  location &&
  typeof updateLocationPricing ===
  'function'
) {

  updateLocationPricing(
    location
  );
}

document.addEventListener(
  'DOMContentLoaded',
  function () {

    updateLocationPricing(
      location
    );

  }
);
    

  

});






